import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BrandInfo } from '../../_models/reports/brand-info.model';
import { BrandFilterService } from '../../_services/brand-filter.service';

/**
 * Multi-select Brand filter for staff list screens. Emits the selected `companyIds`; an empty
 * selection (the default) means every brand the user may see, which is also what the API does with an
 * empty or absent list.
 *
 * Renders nothing when the user has one brand or none — there is nothing to choose between.
 */
@Component({
  selector: 'app-brand-filter',
  templateUrl: './brand-filter.component.html',
  standalone: false
})
export class BrandFilterComponent implements OnInit, OnDestroy {
  @Input() label: string = 'Brand';
  /** The current selection, for restoring a saved filter. */
  @Input() companyIds: number[] = [];
  @Output() companyIdsChange = new EventEmitter<number[]>();

  public brands: BrandInfo[] = [];

  private destroyed = new Subject<void>();

  constructor(private brandFilterService: BrandFilterService) { }

  get visible(): boolean {
    return this.brands.length > 1;
  }

  ngOnInit(): void {
    this.brandFilterService.getMyBrands().pipe(takeUntil(this.destroyed))
      .subscribe(brands => this.brands = brands ?? []);
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  public onSelectionChange(selected: any[]): void {
    this.companyIds = (selected ?? []).map(id => Number(id));
    this.companyIdsChange.emit(this.companyIds);
  }
}
